import styled from 'styled-components';

export const MainForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .header-side {
        margin-bottom: 1em;
    }
`;